import type {
  NotificationSettingResponse,
  UpdateNotificationSettingDto,
  NotificationType,
} from "@repo/share-log-interfaces";
import { z } from "zod";
import type { HttpClient } from "../http";
import type { DataAndMessageResponse } from "../types";

// Schemas
const NotificationTypeSchema = z.string() as z.ZodType<NotificationType>;

const NotificationSettingSchema: z.ZodType<NotificationSettingResponse> =
  z.object({
    id: z.number(),
    workspaceId: z.number(),
    userId: z.number(),
    webPushEnabled: z.boolean(),
    slackEnabled: z.boolean(),
    enabledTypes: z.array(NotificationTypeSchema),
  });

// Response Schemas
const GetNotificationSettingResponseSchema: z.ZodType<
  DataAndMessageResponse<NotificationSettingResponse>
> = z.object({
  data: NotificationSettingSchema,
  message: z.string(),
});

const UpdateNotificationSettingResponseSchema: z.ZodType<
  DataAndMessageResponse<NotificationSettingResponse>
> = z.object({
  data: NotificationSettingSchema,
  message: z.string(),
});

export function createNotificationSettingModule(httpClient: HttpClient) {
  return {
    get: async (workspaceId: number) => {
      const response = await httpClient.get<
        typeof GetNotificationSettingResponseSchema
      >(`/api/v1/workspaces/${workspaceId}/notification-settings`, {
        schema: GetNotificationSettingResponseSchema,
      });
      return response.data;
    },

    update: async (workspaceId: number, data: UpdateNotificationSettingDto) => {
      const response = await httpClient.patch<
        typeof UpdateNotificationSettingResponseSchema
      >(`/api/v1/workspaces/${workspaceId}/notification-settings`, {
        data,
        schema: UpdateNotificationSettingResponseSchema,
      });
      return response.data;
    },
  };
}
